function About() {
  return <div style={{ height: "80vh" }}>ABOUT MORASHA</div>;
}

export default About;
